import React, { Component, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import profPlaceholder from "../../../img/profile-placeholder.png";
import AdminProjectsDetails from "../../AdminTasks/AdminProjects/AdminProjectsDetails";
import userActions from "../../../_actions/userActions";
import { USER } from "../../../_constants/actionConstants";

export default function ProjAssignmentDetails(props) {
  const { projectId, userId, tabId } = props;

  const dispatch = useDispatch();
  const user = useSelector((state) => state.users.openUserDetails[userId] || null);

  useEffect(() => {
    return () => dispatch({ type: USER.CLEAR_USER_DETAILS });
  }, []);

  useEffect(() => userId && dispatch(userActions.getInfoById(userId, tabId)), [userId]);

  return (
    <React.Fragment>
      <div className="card mb-2">
        <div className="card-header bg-lightgray">Selected Project</div>
        <div className="card-body p-3">
          <AdminProjectsDetails
            projectId={projectId}
            collapseDetails={true}
            showButtons={false}
          />
        </div>
      </div>
      <div className="card">
        <div className="card-body p-3">
          {user ? (
            <React.Fragment>
              <h3 className="ml-2">{user.fullName}</h3>
              <h5 className="text-muted ml-2 mb-3">
                {user.userRole?.description ?? "(No Classification)"}
              </h5>
            </React.Fragment>
          ) : (
            <h5 className="text-muted">Select a staff to view details.</h5>
          )}
          {user && (
            <React.Fragment>
              <div className="row">
                <div className="col pr-1">
                  <ul className="list-group-flush pl-0 border-bottom border-top mb-2">
                    <li className="list-group-item py-1 pl-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>Employee ID:</b>
                        </div>
                        <div className="col pl-1">{user.employeeNo}</div>
                      </div>
                    </li>
                    <li className="list-group-item py-1 pl-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>Unit:</b>
                        </div>
                        <div className="col pl-1">
                          {user.unit ? user.unit.distUnit : "(N/A)"}
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item py-1 pl-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>Phone:</b>
                        </div>
                        <div className="col pl-1">{user.phoneNumber}</div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="col pl-1">
                  <ul className="list-group-flush pl-0 border-bottom border-top mb-2">
                    <li className="list-group-item py-1 pl-1">
                      <b>Photo:</b>
                      <br />
                      <img
                        src={profPlaceholder}
                        alt="Profile Placeholder"
                        className="profile-photo"
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
